import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../../contexts/AuthContext";
import {
  LayoutDashboard,
  Package,
  Users,
  Plus,
  LayoutList,
  Star,
  CircleUser,
} from "lucide-react";

const AdminSidebar = ({ onNavigate }) => {
  const location = useLocation();
  const { currentUser } = useAuth();

  const isActive = (path) => location.pathname === path;

  const menuItems = [
    {
      title: "Main menu",
      items: [
        { name: "Dashboard", path: "/admin", icon: LayoutDashboard },
        { name: "Order Management", path: "/admin/orders", icon: Package },
        { name: "Customers", path: "/admin/customers", icon: Users },
      ],
    },
    {
      title: "Product",
      items: [
        { name: "Add Products", path: "/admin/add-product", icon: Plus },
        { name: "Product List", path: "/admin/products", icon: LayoutList },
        { name: "Reviews", path: "/admin/reviews", icon: Star },
      ],
    },
    {
      title: "Admin",
      items: [{ name: "Profile", path: "/admin/profile", icon: CircleUser }],
    },
  ];

  return (
    <div className="w-64 bg-[#0D0806] text-white h-screen overflow-y-auto flex flex-col">
      {/* Logo */}
      <Link
        to="/admin"
        onClick={onNavigate}
        className="flex items-center gap-3 px-6 py-5 border-b border-gray-700"
      >
        <img
          src="/Logo.png"
          alt="Glowy Logo"
          className="h-8 w-8 object-contain flex-shrink-0"
        />
        <span className="text-xl font-bold text-[#DDBB92]">Glowy</span>
      </Link>

      {/* Nav */}
      <nav className="flex-1 px-4 py-6 space-y-6">
        {menuItems.map((section) => (
          <div key={section.title}>
            <h3 className="text-[11px] font-semibold text-gray-400 uppercase tracking-wider mb-3 px-3">
              {section.title}
            </h3>
            <ul className="space-y-1">
              {section.items.map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.path}
                    onClick={onNavigate}
                    className={`flex items-center gap-3 px-3 py-2 rounded-lg transition-colors duration-200 ${
                      isActive(item.path)
                        ? "bg-[#DDBB92] text-[#2B2A29] font-medium"
                        : "text-gray-300 hover:bg-[#E3D2BD] hover:text-[#2B2A29]"
                    }`}
                  >
                    <item.icon className="w-5 h-5 flex-shrink-0" />
                    <span className="text-sm">{item.name}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </nav>

      {/* User block */}
      <div className="px-4 py-4 border-t border-gray-700">
        <div className="flex items-center gap-3 px-2">
          <div className="w-9 h-9 bg-[#DDBB92] rounded-full flex items-center justify-center text-[#2B2A29] font-bold text-sm flex-shrink-0">
            {(currentUser?.displayName || currentUser?.email || "A")[0].toUpperCase()}
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-white truncate">
              {currentUser?.displayName || currentUser?.email?.split("@")[0] || "Admin"}
            </p>
            <p className="text-xs text-gray-400 truncate">
              {currentUser?.email || "admin@glowy.com"}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminSidebar;
